@if (isCorrectAPI) {
  <section role="table" class="PreferencesGrid">
    <!-- HEADER -->
    <section
      role="row"
      class="PreferencesGrid__Row PreferencesGrid__Row--Header"
    >
      <div role="columnheader" class="PreferencesGrid__Cell">
        <p
          class="PreferencesGrid__Label"
          data-test-id="paperlessLabel"
          [innerHTML]="config.title"
        ></p>
      </div>
      @for (column of config.columns; track column; let i = $index) {
        <div
          role="columnheader"
          class="PreferencesGrid__Cell"
          [attr.data-test-id]="'paperlessColumn-' + i"
        >
          <label
            class="u-flex u-alignCenter"
            [ngClass]="{ 'PreferencesGrid--Disabled': column.disabled }"
            (click)="
              column.type === 'multi_select' &&
                !!config.isEditing &&
                toggleAll(column, config.rows)
            "
          >
            @if (!!config.isEditing && column.type === 'multi_select') {
              <input
                type="checkbox"
                class="PreferencesGrid__CheckboxInput"
                role="checkbox"
                (click)="
                  column.type === 'multi_select' &&
                    !!config.isEditing &&
                    toggleAll(column, config.rows)
                "
                [disabled]="column.disabled"
              />
            }
            @if (!!config.isEditing && column.type === 'multi_select') {
              <icon
                [ngClass]="{
                  '--Active': !!isColumnSelected(column, config.rows),
                }"
                [attr.data-test-id]="'paperlessColumn-' + i + '-Icon'"
                [name]="
                  !!isColumnSelected(column, config.rows)
                    ? 'checkbox_active'
                    : 'checkbox'
                "
                [config]="{
                  fill: config.fill || 'link',
                  type: 'svg',
                }"
                [isDisabled]="column.disabled"
              >
              </icon>
            }
            <p
              class="PreferencesGrid__LabelHeader"
              [class.PreferencesGrid__LabelHeader--Exclusive]="
                column.type === 'exclusive_select'
              "
              [attr.data-test-id]="'paperlessColumn-' + i + '-Label'"
              [innerHTML]="column.short_name"
            ></p>
          </label>
        </div>
      }
    </section>
    <!-- BODY -->
    @for (row of config.rows; track row; let r = $index) {
      <section
        role="row"
        class="PreferencesGrid__Row"
        [attr.data-test-id]="'paperlessRow-' + r"
      >
        <!-- LEFT COLUMN -->
        <div
          role="cell"
          class="PreferencesGrid__Cell"
          [attr.data-test-id]="'paperlessRow-' + r + '-RowDescription'"
        >
          <div>
            <p class="PreferencesGrid__Label" [innerHTML]="row.short_name"></p>
            <p
              class="PreferencesGrid__Description"
              [innerHTML]="row.detail_text"
            ></p>
          </div>
        </div>
        <!-- RIGHT COLUMN -->
        @for (column of config.columns; track column; let c = $index) {
          <div
            role="cell"
            class="PreferencesGrid__Cell"
            [ngClass]="{ 'PreferencesGrid--Disabled': column.disabled }"
            [attr.data-test-id]="'paperlessRow-' + r + '-Column-' + c"
          >
            <p
              class="PreferencesGrid__Label PreferencesGrid__Label--Mobile"
              [attr.data-test-id]="
                'paperlessRow-' + r + '-Column-' + c + 'Name'
              "
            >
              {{ column.short_name }}
            </p>
            @if (showCheckbox(column)) {
              <label [attr.for]="'paperlessRow-' + r + '-Column-' + c + 'Icon'">
                @if (!!config.isEditing) {
                  <input
                    type="checkbox"
                    class="PreferencesGrid__CheckboxInput"
                    role="checkbox"
                    (click)="toggleCell(column, row)"
                    [disabled]="column.disabled"
                  />
                }
                @if (!!config.isEditing) {
                  <icon
                    [config]="{
                      fill: config.fill || 'link',
                      type: 'svg',
                    }"
                    class="PreferencesGrid__Checkbox"
                    [name]="
                      !!isCellSelected(column, row)
                        ? 'checkbox_active'
                        : 'checkbox'
                    "
                    (click)="toggleCell(column, row)"
                    [attr.data-test-id]="
                      'paperlessRow-' + r + '-Column-' + c + 'Icon'
                    "
                    [isDisabled]="column.disabled"
                  ></icon>
                } @else {
                  @if (!!isCellSelected(column, row) && !!config.isEnrolled) {
                    <icon
                      [name]="config.checkIcon || 'check'"
                      [config]="{ format: 'svg', fill: config.staticFill }"
                    ></icon>
                  }
                }
              </label>
            }
            @if (column.type === 'exclusive_select') {
              <label [attr.for]="'paperlessRow-' + r + '-Column-' + c + 'Icon'">
                <input
                  type="radio"
                  class="PreferencesGrid__Input"
                  role="radiogroup"
                  [attr.name]="'paperlessRow-' + r + '-Column'"
                  (click)="toggleCell(column, row)"
                  [attr.id]="'paperlessRow-' + r + '-Column-' + c + 'Icon'"
                  [disabled]="column.disabled"
                />
                <icon
                  [config]="{
                    fill: config.fill || 'link',
                    type: 'svg',
                  }"
                  class="PreferencesGrid__Radio"
                  [name]="
                    !!isCellSelected(column, row) ? 'radio_active' : 'radio'
                  "
                  (click)="toggleCell(column, row)"
                  [attr.data-test-id]="
                    'paperlessRow-' + r + '-Column-' + c + 'Icon'
                  "
                  [isDisabled]="column.disabled"
                >
                </icon>
              </label>
            }
          </div>
        }
      </section>
    }
  </section>
} @else {
  <message-banner
    [config]="errorMessageConfig"
    data-test-id="gridIncorrectAPIErrorMessage"
  ></message-banner>
}
